import { Permission, TagGroupType } from "@edgetier/watchtower-types";
import Page from "constants/page";
import { createContext } from "react";
import { ITagsListContext } from "./tags-list-context.types";

export const defaultContext: ITagsListContext = {
    tagGroupType: TagGroupType.PhraseSearch,
    showExploreAction: true,
    redirectRoute: Page.ManageTags,
    actionPermissions: Permission.ManagePhraseTriggers,
    showTagGroupUnaryForAgents: false,
};

const TagsListContext = createContext(defaultContext);
export default TagsListContext;
